export const fileMangerAPI = {
  getFiles: 'v1/api/userFileMaster/files?',
  getFileDownloadLink: 'v1/api/userFileMaster/fileDetails?Id=',
  updateFileFolderName: 'v1/api/userFileMaster/updateFolder?Id=',
  createNewFolder: 'v1/api/userFileMaster/createFolder',
  deleteFolder: 'v1/api/userFileMaster/removeFolder?Id=',
  deleteFile: 'v1/api/userFileMaster/removeFile?Id=',
  upadteImportant: 'v1/api/userFileMaster/updateFile?',
  uploadFile: 'v1/api/userFileMaster/upload',
  getUsersList: 'v1/api/users?displayType=readAll&status=true',
  updateSharedList: 'v1/api/userFileMaster/updateFile?type=5',
  moveTheDocument: 'v1/api/userFileMaster/moveFile',
  sendFileSharingMail: 'v1/api/userMailMaster/incoming-email/sendFileSharingMail',
  fileMangerV3: 'v1/api/userFileMaster/generate-token',
};
